import { formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'cv-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimePickerComponent),
        multi: true
    }]
})
export class TimePickerComponent implements ControlValueAccessor, OnInit {
    @Output() ngChange = new EventEmitter<any>();

    use24Hour = false;
    placeholderDate: Date;
    timeFormat: string;
    ngbModel: NgbTimeStruct;

    // ngModel requirements
    model: Date;
    modelDisplay: string;
    disabled: boolean;

    constructor(
        @Inject(LOCALE_ID) private locale: string,
        private element: ElementRef<HTMLElement>,
        private _cd: ChangeDetectorRef,
    ) {
        const CVTimeFormat: string = window['CVTimeFormat'];
        this.timeFormat = window['CVAngularTimeFormat'];
        this.use24Hour = CVTimeFormat.includes('H');
        this.placeholderDate = Date.today();
    }

    onChange = (_: any) => { };
    onTouched = () => { };

    updateModelDisplay() {
        this.modelDisplay = formatDate(this.model, this.timeFormat, this.locale);
    }

    writeValue(value: Date) {
        this.model = value ?? new Date(this.placeholderDate);
        this.updateModelDisplay();
        this.ngbModel = {
            hour: this.model.getHours(),
            minute: this.model.getMinutes(),
            second: this.model.getSeconds(),
        };
        this._cd.markForCheck();
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void) {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean) {
        this.disabled = isDisabled;
        this._cd.markForCheck();
    }

    ngOnInit() {
        this.model = this.model ?? new Date(this.placeholderDate);
        this.updateModelDisplay();
    }

    focusInput() {
        this.element.nativeElement.querySelector<HTMLInputElement>('input.tp-time').focus();
    }

    onTimePickerChanged() {
        this.model = this.model ?? new Date(this.placeholderDate);
        if (this.ngbModel != null) {
            this.model.setHours(this.ngbModel.hour);
            this.model.setMinutes(this.ngbModel.minute);
            this.model.setSeconds(this.ngbModel.second);
        } else {
            this.model = new Date(this.placeholderDate);
        }
        this.updateModelDisplay();
        this.onTouched();
        this.onChange(this.model);
        this.ngChange?.emit(this.model);
    }
}
